import ArticleLifeManager from './ArticleLifeManager'
export default ArticleLifeManager
